var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.2891 25.2237V18.1447L74.0585 11.0332L74.578 20.4881",
  fill: "#D1C8B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.2888 25.2237V18.1447L0.421875 11.0332V20.4881",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.7109 57.5264L37.2888 79.3166L0.421875 62.262L37.7109 57.5264Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.7109 69.6176L74.9999 62.262L37.7109 57.5264V69.6176Z",
  fill: "#D1C8B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.1647 15.6712L37.2913 18.1447L14.418 14.4506L24.2394 11.0332L50.1647 15.6712Z",
  fill: "#BDB09B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2109 0V13.1327L42.2077 15.6714L74.448 20.4883L73.9934 11.0497L25.2109 0Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.211 0L0.227273 11.0497L0 20.4883L16.4935 15.6714L25.211 13.1327V0Z",
  fill: "#F2EFEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4715 56.4367L25.7962 47.3887H19.0754L17.6143 50.0901C16.5916 52.0103 15.163 54.7118 14.4163 56.5669C14.4812 54.6792 14.5299 52.5799 14.5299 50.3016V47.3887H8.52344V72.3197H14.5299V64.0202L16.0234 61.8558L19.6111 72.3197H26.2507L20.4715 56.4367Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1766 59.8863C37.1766 65.9075 36.2513 67.5837 34.4006 67.5837C32.55 67.5837 31.5922 65.8424 31.5922 59.8212C31.5922 53.8 32.485 52.1239 34.3681 52.1239C36.2188 52.1239 37.1766 53.8651 37.1766 59.8863ZM43.2805 59.805C43.2805 51.0498 39.9688 46.9814 34.4006 46.9814C28.8162 46.9814 25.4883 51.0824 25.4883 59.87C25.4883 68.6577 28.7513 72.6936 34.3357 72.6936C39.9526 72.7098 43.2805 68.6089 43.2805 59.805Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.4797 49.1455H43.457V54.3368H48.5057V74.0765H54.431V54.3368H59.4797V49.1455Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.6159 47.3887H61.6094V72.3197H67.6159V47.3887Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.959162 90.5949L25.4884 109V69.6183L0.277344 62.2627L0.959162 90.5949Z",
  fill: "#F2EFEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4883 69.6183V109L73.6701 90.5949L75.0013 62.2627L25.4883 69.6183Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.876 41.7414C19.3013 41.7414 18.4734 40.2442 18.4734 35.1018C18.4734 29.9594 19.2363 28.511 20.8435 28.511C22.4182 28.511 23.2461 30.0082 23.2461 35.1506C23.2461 40.3093 22.4506 41.7414 20.876 41.7414ZM20.876 24.1172C16.1032 24.1172 13.2461 27.616 13.2461 35.1506C13.2461 42.6852 16.0383 46.119 20.811 46.119C25.6162 46.119 28.4734 42.6202 28.4734 35.0855C28.4734 27.5997 25.6487 24.1172 20.876 24.1172Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.3157 20.293L39.6566 20.6998L38.228 26.1677C37.4975 28.9179 36.9131 31.4892 36.7345 33.0352C36.3287 31.538 35.2573 29.0481 34.1209 26.5583L31.7345 21.3996L27.043 21.8064L28.9423 43.4828L33.6339 43.0759L33.2118 38.2752C33.017 35.9481 32.7573 33.7837 32.5462 31.9936C33.1631 33.6536 34.267 36.3061 35.1436 38.1613L37.6599 43.4014L39.2183 37.8033C39.7865 35.8179 40.3871 33.0189 40.6956 31.2776C40.7605 33.1491 40.9228 35.2484 41.1176 37.5755L41.5397 42.3762L46.1988 41.9693L44.3157 20.293Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.5924 23.1895H49.2353L43.5859 45.0773H48.9431L49.7223 41.009H54.0242L54.8359 45.0773H60.1931L54.5924 23.1895ZM50.5827 36.7616L50.7126 36.0781C51.2483 33.1651 51.6866 30.7892 51.8652 28.7875C52.0762 30.7892 52.547 33.1651 53.0502 36.0455L53.1801 36.7616H50.5827Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 109,
  fill: "white"
})));

function SvgOmaKotiLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 109,
    viewBox: "0 0 75 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmaKotiLogoWhite);
export default __webpack_public_path__ + "static/media/omaKotiLogoWhite.4124c4fea8de3c5f7229eb3594b19a23.svg";
export { ForwardRef as ReactComponent };